import React from "react";
import { Modal } from "../../Components";
import { Archive, RotateCcw, AlertCircle } from "lucide-react";

export default function ModalReportConfirm({ close, confirmFor, onConfirm }) {
  const isArchive = confirmFor === "archived";
  const actionText = isArchive ? "Archive" : "Restore";

  return (
     <Modal
          close={close}
          aria-labelledby="application-details-modal"
          aria-describedby="application-details-description"
          className="!flex !items-center !justify-center p-4 "
          modelInnerClass="!max-w-[500px] !w-full"
        >
      <div className="bg-white rounded-2xl max-w-[400px] w-full overflow-hidden" >
        <div className="p-8 flex flex-col items-center text-center">
          {/* Icon Section */}
          <div 
            className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 transition-transform duration-300 hover:scale-110 ${
              isArchive 
                ? "bg-orange-50 text-orange-500 border border-orange-100" 
                : "bg-emerald-50 text-emerald-500 border border-emerald-100"
            }`}
          >
            {isArchive ? (
              <Archive size={32} strokeWidth={2.2} />
            ) : (
              <RotateCcw size={32} strokeWidth={2.2} />
            )}
          </div>

          {/* Content Section */}
          <h3 className="text-xl font-bold text-gray-900 mb-3 tracking-tight">
            Confirm {actionText}
          </h3>
          
          <div className="text-gray-500 leading-relaxed mb-8">
            <p>
              Are you sure you want to <span className="font-semibold text-gray-800">{actionText.toLowerCase()}</span> this report?
            </p>
            {isArchive && (
              <div className="mt-3 flex items-center justify-center gap-2 text-sm text-orange-600 bg-orange-50/50 py-2 px-3 rounded-lg border border-orange-100/50">
                <AlertCircle size={14} strokeWidth={2.5} />
                <span>This will move it to the archive tab.</span>
              </div>
            )}
          </div>

          {/* Actions Section */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <button
              onClick={close}
              className="flex-1 py-3 px-6 rounded-xl border border-gray-200 text-gray-600 font-semibold text-sm hover:bg-gray-50 active:bg-gray-100 transition-all duration-200"
            >
              Cancel
            </button>
            <button
              onClick={() => onConfirm()}
              className={`flex-1 py-3 px-6 rounded-xl text-white font-bold text-sm shadow-lg transition-all duration-200 active:scale-98 hover:shadow-xl ${
                isArchive 
                  ? "bg-gradient-to-br from-orange-500 to-orange-600 shadow-orange-200/50 hover:from-orange-600 hover:to-orange-700" 
                  : "bg-gradient-to-br from-emerald-500 to-emerald-600 shadow-emerald-200/50 hover:from-emerald-600 hover:to-emerald-700"
              }`}
            >
              {actionText}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
